import network from './slices/networkSlice'
import loader from './slices/loaderSlice'
import message from './slices/messageSlice'
import auth from './slices/authSlice'
import user from './slices/userSlice'
import overview from './slices/overviewSlice'
import campaign from './slices/campaignSlice'
import billing from './slices/billingSlice'
import report from './slices/reportSlice'

const reducer = {
  network,
  loader,
  message,
  auth,
  user,
  overview,
  campaign,
  billing,
  report
};

export default reducer;